// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"674":"ca782da4","913":"58024543"}[chunkId] + ".chunk.css";
};